import { getJson, withMap } from '@rad/utility/http';
const processMerchant = (x) => {
    return Object.assign({}, x);
};
export const fetchMerchant = (merchantId) => withMap(getJson(`/merchants/${merchantId}`), processMerchant);
